import React from 'react';

export const Section = ({ label, children }) => {
  const h3ClassName = 'section text-[12px] text-flint font-[600] mt-0 tracking-[0.5px] leading-[14px] uppercase pb-[15px] mb-[25px] border-solid border-b border-gray-medium';
  const sectionClassName = 'mb-[50px] last:mb-0';
  
  return (
  <div className={sectionClassName}>
    {label && <h3 className={h3ClassName}>{label}</h3>}
    {children}
  </div>
  );
};
